<template>
  <div class="text-center">
    <div class="signin-text text-center" style="margin-bottom: 10px">Мы отправили вам ссылку для входа на почту</div>
    <p style="margin-bottom: 10px">
      <b>{{ mail }}<a :href="href">{{ domain }}</a></b>
    </p>
    <p style="margin-bottom: 10px">Чтобы зайти в личный кабинет перейдите по ссылке из письма.</p>
  </div>
</template>

<script>
export default {
  name: 'AcceptLoginEmail',

  props: {
    login: String
  },

  data () {
    return {
      mail: String,
      domain: String,
      href: String
    }
  },

  created: function () {
    this.mail = this.login.substr(0, this.login.indexOf('@') + 1)
    this.domain = this.login.substr(this.mail.length)
    this.href = 'http://' + this.domain
  }
}
</script>
